import { lazy } from 'react';

export const ShortContract = lazy(() => import('./ShortContract.component'));
